import { Helmet } from 'react-helmet-async';
import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AppShellNav from '../shell/AppShellNav';
import AppShellToolbar from '../shell/AppShellToolbar';
import ButtonCloudSync from './ButtonCloudSync';
import TransactionalAppBoundary from './TransactionalAppBoundary';
import '../shell/appShell.css';

/** Layout premium: shell de marca en nav/volver; contenido interno sin cambios. */
export default function PremiumAppLayout({
  title,
  description,
  keywords,
  backRoute = '/apps',
  children,
  showCloudSyncButton = true,
  contentMaxWidth,
}) {
  const navigate = useNavigate();

  const handleSmartBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate(backRoute, { replace: true });
    }
  };

  return (
    <div className="app-shell">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
      </Helmet>

      <AppShellNav />

      <main className="app-shell-main">
        <div className="apps-wrap" style={contentMaxWidth ? { maxWidth: contentMaxWidth, width: '100%', boxSizing: 'border-box' } : undefined}>
          <AppShellToolbar
            onBack={handleSmartBack}
            trailing={
              showCloudSyncButton ? (
                <div className="app-shell-sync">
                  <ButtonCloudSync />
                </div>
              ) : null
            }
          />
          <Container maxWidth={false} disableGutters sx={{ py: { xs: 1, sm: 3 }, width: '100%' }}><TransactionalAppBoundary>{children}</TransactionalAppBoundary></Container>
        </div>
      </main>
    </div>
  );
}
